export const LocationSearch = ({ onClick, className }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <g clipPath="url(#clip0_3967_37941)">
        <path
          d="M20.94 11.6016C20.48 7.43156 17.17 4.12156 13 3.66156V1.60156H11V3.66156C6.83 4.12156 3.52 7.43156 3.06 11.6016H1V13.6016H3.06C3.52 17.7716 6.83 21.0816 11 21.5416V23.6016H13V21.5416C17.17 21.0816 20.48 17.7716 20.94 13.6016H23V11.6016H20.94ZM12 19.6016C8.13 19.6016 5 16.4716 5 12.6016C5 8.73156 8.13 5.60156 12 5.60156C15.87 5.60156 19 8.73156 19 12.6016C19 16.4716 15.87 19.6016 12 19.6016Z"
          fill="#070707"
        />
      </g>
      <defs>
        <clipPath id="clip0_3967_37941">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.601562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
